/* WorkTriggerWorkInputTabComponent.js */

"use strict";
const Renderer = require("./WorkTriggerWorkInputTabRenderer");

class WorkTriggerWorkInputTabComponent {
    constructor(workTriggerDetailsView) {
        this._renderer = new Renderer(workTriggerDetailsView);
    }
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        return Promise.resolve();
    }
}
module.exports = WorkTriggerWorkInputTabComponent;
